// SQL practice results include tests on versions of the data students never
// see. They're reported together, so one hidden failure doesn't print the
// same message four times or hint at which variation broke.
const HIDDEN = / - hidden test \d+$/i;

export function isHiddenTest(test) {
  return HIDDEN.test(test?.name || "");
}

export function hiddenTestSummary(tests) {
  const hidden = tests.filter(isHiddenTest);
  if (hidden.length === 0) return [];
  const passed = hidden.filter((t) => t.status === "passed").length;
  const firstFailure = hidden.find((t) => t.status !== "passed" && t.output);
  const lines = [`${passed === hidden.length ? "✅" : "❌"} Hidden tests: passed ${passed} of ${hidden.length}`];
  if (firstFailure) lines.push(firstFailure.output.trim());
  lines.push("");
  return lines;
}
